import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Dialog } from '@material-ui/core';

import content from './PaymentErrorModal.json';
import {
  ModalWrap,
  Title,
  ErrorText,
  ButtonGrid,
  DarkButton,
  LightButton,
} from '@components/Modals/PaymentError/PaymentError.styles';
import { getLanguagePrefix } from '@helpers';
import { getLocalizedContent as l } from '@helpers/languages';

const PaymentError = ({ open, onClose, errorText, onChangeMethod }) => {
  const dispatch = useDispatch();
  const { language, prefixLanguage } = useSelector(({ appState }) => appState);

  const handleRefresh = () => {
    if (typeof window !== `undefined`) {
      window.location.reload();
    }
  };

  const handleBackToPayment = () => {
    onChangeMethod();
  };

  return (
    <Dialog onClose={onClose} open={open}>
      <ModalWrap>
        <Title>{l(content.title, language)}</Title>
        <ErrorText>{errorText}</ErrorText>

        <Grid justifyContent="center">
          {/* <DarkButton onClick={handleRefresh}>
          {l(content.refreshCTA, language)}
        </DarkButton> */}
          <LightButton onClick={handleBackToPayment}>
            {l(content.backToPayment, language)}
          </LightButton>
        </Grid>
      </ModalWrap>
    </Dialog>
  );
};

export default PaymentError;
